import React from "react";
import ReactDOM from "react-dom";
import config from "./config";
import { appendGtagScriptToHead } from "./lib/googleAnalytics";
import loadConfig from "./loadConfig";
import PageError from "./pages/PageError";
import * as serviceWorker from "./serviceWorker";

function createApp() {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const App = require("./App").default;
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
}

function setTitle() {
  const titleTag = document.createElement("TITLE");
  const siteName = document.createTextNode(config.siteName);
  titleTag.appendChild(siteName);
  document.head.appendChild(titleTag);
}

loadConfig()
  .then(() => appendGtagScriptToHead())
  .then(() => setTitle())
  .then(() => createApp())
  .catch((e) => {
    ReactDOM.render(
      <React.StrictMode>
        <PageError error={e} />
      </React.StrictMode>,
      document.getElementById("root")
    );
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
